import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { MessageCircle, Phone, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

// Message + Call — shown only after acceptance and payment, closed 24 h after delivery.
const ContactButtons = ({ delivery, role }) => {
  const [busy, setBusy] = useState(false);
  const c = delivery?.contact;
  if (!c) return null;
  const call = async () => {
    setBusy(true);
    try {
      const r = await api.post("/calls/initiate", { parcel_id: delivery.parcel_id, role });
      if (r.data.status === "unavailable") toast.info(r.data.message);
      else toast.success(r.data.message || "Connecting your call…");
    } catch (e) { toast.error(e?.response?.data?.detail || "Couldn't start the call."); }
    setBusy(false);
  };
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="contact-buttons">
      <Button asChild={c.available} disabled={!c.available} size="sm" className="rounded-full bg-slate-900 hover:bg-slate-800" data-testid="contact-message-btn">
        {c.available ? <Link to={`/delivery/${delivery.id}#chat`}><MessageCircle className="w-4 h-4 mr-1"/> Message</Link> : <span><MessageCircle className="w-4 h-4 mr-1 inline"/> Message</span>}
      </Button>
      <Button size="sm" variant="outline" className="rounded-full" disabled={!c.available || busy} onClick={call} data-testid="contact-call-btn">
        {busy ? <Loader2 className="w-4 h-4 animate-spin"/> : <><Phone className="w-4 h-4 mr-1"/> Call</>}
      </Button>
      {!c.available && <span className="text-[11px] text-slate-500" data-testid="contact-unavailable-reason">{c.reason}</span>}
    </div>
  );
};

export default ContactButtons;
